// extracted by mini-css-extract-plugin
export var cardContainer = "_r6-0";
export var cardHeader = "_r6-2";
export var collapsedState = "_r6-3";
export var dragHandle = "_r6-5";
export var dragHandleIcon = "_r6-6";
export var dragging = "_r6-1";
export var titleArea = "_r6-4";